<template>
  <div id="newTaskExport" class="padding-max border-radius-top-t">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-form ref="form" class="contNewTask">
      <div class="header">
        <span class="textHeader">Configuración exportación automática</span>
      </div>
      <div class="content">
        <div class="contSelect">
          <span class="subTitle">Frecuencia</span>
          <v-chip-group v-model="freq" column>
            <v-chip class="custom" value="daily"> Diaria </v-chip>
            <v-chip class="custom" value="weekly"> Semanal </v-chip>
          </v-chip-group>
        </div>
        <div class="contSelect" v-if="freq == 'weekly'">
          <span class="subTitle">Dia de la semana</span>
          <v-chip-group class="custom" v-model="dayOfWeek" column>
            <v-chip
              class="custom"
              v-for="item in week"
              :value="item.value"
              :key="item.value"
            >
              {{ item.name }}
            </v-chip>
          </v-chip-group>
        </div>
        <div class="contSelect">
          <span class="subTitle">Hora</span>
          <v-menu
            ref="menu"
            v-model="menu"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
            color="#27e96a"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="time"
                placeholder="Seleccionar"
                append-icon="mdi-clock-time-four-outline"
                readonly
                :rules="requiredRules"
                v-on="on"
                required
                color="#27e96a"
              >
              </v-text-field>
            </template>
            <v-time-picker
              v-if="menu"
              :value="time"
              full-width
              @click:hour="closePicker"
              :allowed-minutes="[0]"
              color="#27e96a"
              header-color="black"
            ></v-time-picker>
          </v-menu>
        </div>
        <div class="contSelect">
          <span class="subTitle">Proveedor</span>
          <v-select
            color="#27e96a"
            v-model="provider"
            :rules="requiredRules"
            placeholder="Seleccionar"
            item-value="id"
            :items="listStorage"
            :item-text="(items) => `${items.nameBucket}`"
          ></v-select>
        </div>
        <div class="contSelect">
          <span class="subTitle">Formato de etiqueta</span>
          <v-select
            color="#27e96a"
            v-model="hashtag"
            :rules="requiredRules"
            placeholder="Seleccionar"
            :items="listFilenameFormat"
            :item-value="(items) => items"
            :item-text="(items) => `${items.filename_format}`"
          ></v-select>
        </div>
        <div class="contSelect">
          <span class="subTitle">Encarpetamiento de archivos</span>
          <div class="contComboInfo">
            <v-combobox
              v-model="chips"
              :items="items"
              chips
              clearable
              multiple
              prepend-icon="mdi-filter-variant"
              :rules="[required]"
              class="custom"
            >
              <template v-slot:selection="{ attrs, item }">
                <v-chip
                  draggable
                  v-bind="attrs"
                  :color="chipValidate(item) ? 'default' : 'red'"
                  close
                  @click:close="remove(item)"
                >
                  <strong>{{ item }}</strong>
                </v-chip>
              </template>
            </v-combobox>
            <div @click="dialog = true">
              <v-icon>mdi-information</v-icon>
            </div>
          </div>
        </div>
        <div class="contAudioPrefix" v-if="hashtag">
          <v-icon color="#27e96a">mdi-music</v-icon>
          <span>{{ hashtag.filename_format }}</span>
        </div>
        <div class="contBtn">
          <div class="btnCancel button-primary" @click="back()">
            <span>Cancelar</span>
          </div>
          <div @click="saveTaskExport()" class="btnSave button-tertiary">
            <span>Guardar</span>
          </div>
        </div>
      </div>
    </v-form>
    <Help v-if="dialog" :show="dialog" @closeDialog="dialog = false"></Help>
    <v-snackbar v-model="showError" color="red" :timeout="2000" max-width="100">
      {{ textError }}
    </v-snackbar>
  </div>
</template>
<script>
import Help from "@/components/task-export/help";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      freq: null,
      dayOfWeek: null,
      time: null,
      hour: null,
      menu: false,
      hashtag: null,
      provider: null,
      chips: [],
      items: [],
      dialog: false,
      requiredRules: [(v) => !!v || "Campo requerido"],
      fre: [
        { name: "Diaria", value: "daily" },
        { name: "Semanal", value: "weekly" },
      ],
      week: [
        { name: "DOM", value: 1 },
        { name: "LUN", value: 2 },
        { name: "MAR", value: 3 },
        { name: "MIE", value: 4 },
        { name: "JUE", value: 5 },
        { name: "VIE", value: 6 },
        { name: "SAB", value: 7 },
      ],
      showError: false,
      textError: null,
      loading: false,
    };
  },
  mounted() {
    this.$store.dispatch("filenameFormat/getFilenameFormat");
    this.$store.dispatch("storage/getAllStorage");
    this.getTaskExport();
  },
  computed: {
    ...mapGetters("task", { taskExport: "taskExport" }),
    ...mapGetters("filenameFormat", {
      listFilenameFormat: "filenameFormatTable",
    }),
    ...mapGetters("storage", { listStorage: "storageTable" }),
  },
  methods: {
    back() {
      this.$router.push("/task");
    },
    remove(item) {
      this.chips.splice(this.chips.indexOf(item), 1);
      this.chips = [...this.chips];
    },
    async saveTaskExport() {
      if (
        this.$refs.form.validate() &&
        (this.freq == "daily" ||
          (this.freq == "weekly" && this.dayOfWeek !== null))
      ) {
        this.loading = true;
        let json = {};
        const offset = new Date().getTimezoneOffset();
        const tdiff = Math.ceil(offset / 60);
        let sendHour = this.hour + tdiff;
        let sendDayOfWeek = this.dayOfWeek;
        if (sendHour > 23) {
          sendHour = sendHour - 24;
          if (this.freq == "weekly") {
            if (sendDayOfWeek == 7) {
              sendDayOfWeek = 1;
            } else {
              sendDayOfWeek = sendDayOfWeek + 1;
            }
          }
        }
        if (this.freq == "daily") {
          json = {
            type: this.freq,
            hour: sendHour,
            path: this.path(),
            format: this.hashtag.id,
            storageId: parseInt(this.provider),
            compress: false,
            enabled: true,
          };
        } else {
          json = {
            type: this.freq,
            hour: sendHour,
            dow: sendDayOfWeek,
            path: this.path(),
            format: this.hashtag.id,
            storageId: parseInt(this.provider),
            compress: false,
            enabled: true,
          };
        }
        try {
          await this.$store.dispatch("task/createTaskExport", json);
          this.$router.push("/task");
        } catch (error) {
          this.textError = error;
          this.showError = true;
        }
        this.loading = false;
      }
    },
    path() {
      let string = "";
      for (let i = 0; i < this.chips.length; i++) {
        if (i == 0) {
          string += this.chips[i];
        } else {
          string += "/" + this.chips[i];
        }
      }
      return string;
    },
    required(value) {
      if (value instanceof Array && value.length == 0) {
        return "Campo requerido";
      }
      if (value instanceof Array && value.length > 0) {
        for (let i = 0; i < value.length; i++) {
          if (value[i].startsWith("{") && !value[i].endsWith("}")) {
            return "Error en el formato";
          } else if (!value[i].startsWith("{") && value[i].endsWith("}")) {
            return "Error en el formato";
          }
        }
      }
      return !!value || "Campo requerido";
    },
    chipValidate(value) {
      if (value.startsWith("{") && value.endsWith("}")) {
        return true;
      } else if (value.startsWith("{") && !value.endsWith("}")) {
        return false;
      } else if (!value.startsWith("{") && value.endsWith("}")) {
        return false;
      } else {
        return true;
      }
    },
    closePicker(v) {
      this.hour = v;
      v = v < 10 ? "0" + v : v;
      this.time = v + ":00";
    },
    async getTaskExport() {
      this.loading = true;
      try {
        await this.$store.dispatch("task/getTaskExport");
        if (Object.keys(this.taskExport).length > 1) {
          this.freq = this.taskExport.type;
          if (this.freq == "weekly") {
            this.dayOfWeek = this.taskExport.dow;
          }
          this.setFileFormat();
          this.provider = this.taskExport.storageId;
          this.hour = this.taskExport.hour;
          const offset = new Date().getTimezoneOffset();
          const tdiff = Math.ceil(offset / 60);
          this.hour = this.hour - tdiff;
          if (this.hour < 0) {
            this.hour = this.hour + 24;
            let v = this.hour;
            v = v < 10 ? "0" + v : v;
            this.time = v + ":00";
            if (this.freq == "weekly") {
              if (this.dayOfWeek == 1) {
                this.dayOfWeek = 7;
              } else {
                this.dayOfWeek = this.dayOfWeek - 1;
              }
            }
          } else {
            let v = this.hour;
            v = v < 10 ? "0" + v : v;
            this.time = v + ":00";
          }
          const pathArray = this.taskExport.path.split("/");
          if (this.taskExport.path.startsWith("/")) {
            pathArray.splice(0, 1);
          }
          for (let i = 0; i < pathArray.length; i++) {
            this.chips[i] = pathArray[i];
          }
          this.items = this.chips;
        }
      } catch (error) {
        this.textError = error;
        this.showError = true;
      }
      this.loading = false;
    },
    async setFileFormat() {
      await this.$store.dispatch("filenameFormat/getFilenameFormat");
      const format = this.listFilenameFormat.find(
        (item) => item.id === this.taskExport.format
      );
      this.hashtag = format;
    },
  },
};
</script>
<style lang="scss">
#newTaskExport {
  padding: 2rem;
  margin: -12px;
  border-radius: 5px;
  width: auto;
  height: calc(100vh - 64px);
  animation: fade 1s ease-in-out;
  .contNewTask {
    width: 100%;
    background: #ffffff;
    border-radius: 5px;
    .header {
      width: 100%;
      background: $primary-color;
      padding: 15px 20px;
      border-radius: 5px;
      .textHeader {
        color: #ffffff;
        font-size: 24px;
      }
    }
    .content {
      padding: 10px 0;
      margin: 0 15px;
      .contSelect {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        .frequency {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
          .btn {
            border: 1px solid #e0e1e3;
            border-radius: 25px;
            cursor: pointer;
            padding: 4px 10px;
            user-select: none;
            span {
              font-size: 14px;
              cursor: pointer;
              user-select: none;
            }
            &.active {
              background: $primary-color;
              border: 1px solid $primary-color;
              span {
                color: #ffffff;
              }
            }
          }
        }
      }
    }
    .contBtn {
      border-top: 1px solid #e3e4e6;
      display: flex;
      justify-content: flex-end;
      margin: 20px 0 0 0;
      padding: 15px 0 0 0;
      .btnCancel {
        border: 1px solid #4976f8;
        border-radius: 3px;
        padding: 4px 5px;
        width: 100%;
        max-width: 180px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        span {
          cursor: pointer;
        }
      }
      .btnSave {
        border-radius: 3px;
        padding: 4px 5px;
        width: 100%;
        max-width: 180px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 15px;
        cursor: pointer;
        span {
          cursor: pointer;
        }
      }
    }
  }
  .inputCustom {
    border: 1px solid #e0e1e3;
    border-radius: 4px;
    padding: 4px 10px;
    font-size: 14px;
    margin-top: 5px;
    width: fit-content;
    min-width: 330px;
    &::placeholder {
      color: #e0e1e3;
    }
    select:invalid {
      color: gray;
    }
    option[disabled] {
      color: #e0e1e3;
    }
    .disabled {
      color: #e0e1e3;
    }
  }
  .subTitle {
    font-size: 14px;
    font-weight: 500;
  }
  .v-input {
    &.custom {
      max-width: 620px;
      .v-input__slot {
        box-shadow: none;
        border-bottom: 1px solid #e0e1e3;
        border-radius: 0px;
        margin-bottom: 0px;
      }
      .v-text-field__details {
        min-height: 0px;
      }
    }
    max-width: 420px;
  }
  .v-chip {
    &.custom {
      border: 1px solid #e0e1e3;
      background: #ffffff;
    }
    &--active {
      background: $primary-color !important;
      border: 1px solid $primary-color !important;
      span {
        color: #ffffff;
      }
    }
  }
  .contAudioPrefix {
    border: 1px solid #e0e1e3;
    width: fit-content;
    padding: 2px 10px;
    border-radius: 15px;
    display: flex;
    justify-content: center;
    align-items: center;

    margin-left: 30px;
    svg {
      margin-right: 10px;
    }
    span {
      font-size: 14px;
    }
  }
  .contComboInfo {
    display: flex;
    align-items: center;
    .help {
      position: relative;
      width: 30px;
      height: 30px;

      border-radius: 100%;
      cursor: pointer;
      margin-left: 20px;
      svg {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
      }
    }
  }
  @keyframes fade {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
}
</style>
